<nz-modal [nzBodyStyle]="{ overflow: 'auto', height: '400px' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
  [nzVisible]="isVisibleUserDrawer" [nzTitle]="userDrawerTitle" [nzFooter]="footerTpl" (nzOnCancel)="handleCancel()">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="_fS.userForm">
      <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="firstNameError">
              <label class="label-text required">First name</label>
              <input class="input-group" nz-input formControlName="firstName" (keypress)="_cs.checkAlphabets($event)"
                minlength="2" maxlength="100" placeholder="Enter First Name" />
              <ng-template #firstNameError let-control>
                <ng-container *ngIf="control.hasError('required')">Please enter firstname</ng-container>
                <ng-container *ngIf="control.hasError('minlength')">First name must contain at least 2 characters
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="lastNameError">
              <label class="label-text required">Last name</label>
              <input class="input-group" nz-input formControlName="lastName" (keypress)="_cs.checkAlphabets($event)"
                minlength="2" maxlength="100" placeholder="Enter Last Name" />
              <ng-template #lastNameError let-control>
                <ng-container *ngIf="control.hasError('required')">Please enter lastname</ng-container>
                <ng-container *ngIf="control.hasError('minlength')">Last name must contain at least 2 characters
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="emailAddressError">
              <label class="label-text required">Email address</label>
              <input autocomplete="off" class="input-group" nz-input formControlName="emailAddress" name="fname"
                pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}" placeholder="Enter Email Address" />
              <ng-template #emailAddressError let-control>
                <ng-container *ngIf="control.hasError('required')">Please enter email address
                </ng-container>
                <ng-container *ngIf="control.hasError('pattern')">Enter valid email address
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="roleError">
              <label class="label-text required">Role</label>
              <nz-select nzShowSearch nzPlaceHolder="Select Role" [nzSize]="'default'" formControlName="role"
                (ngModelChange)="onSelectRole($event)" [nzSelectOnTab]="true">
                <nz-option *ngFor="let option of listOfRoles" [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
              </nz-select>
              <ng-template #roleError let-control>
                <ng-container *ngIf="control.hasError('required')">Please select role</ng-container>
              </ng-template>
              <p>{{ descriptionToShow }}</p>
            </nz-form-control>
          </nz-form-item>
        </div>
        <!--
          Optional. The form already submitted phoneNumber from a control that was never rendered, so
          every user created here had an empty number and met a mandatory phone step at activation.
        -->
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="phoneError">
              <label class="label-text">Phone number</label>
              <!-- [validation]="false": the mask only formats. Its own length check would block saving a user whose
                   stored number predates the 10-digit rule, with no message; phone-validators.ts does the real check. -->
              <nz-input-group>
                <input class="input-group" nz-input formControlName="phoneNumber"
                  (keypress)="_cs.checkNumbers($event)" (blur)="showPhoneErrors()" [validation]="false" mask="(000) 000-0000"
                  placeholder="Enter phone number" />
              </nz-input-group>
              <ng-template #phoneError let-control>
                <ng-container *ngIf="control.hasError('pattern')">
                  Enter a valid mobile number
                </ng-container>
                <ng-container *ngIf="control.hasError('incomplete')">
                  Phone number must be 10 digits
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
          <nz-form-item>
            <nz-form-control>
              <label class="label-text required">Sites</label>
              <!-- (DropDownChanged)="sitesChanged($event)" -->
              <gs-select [selectDataParentChild]="sitesData" [showAllCheckbox]="false" [allowMultiSelect]="true"
                [isParentChild]="true" [showSearch]="false" (DropDownChanged)="sitesDropdownChanged($event)"
                [ngClass]="showSitesInvalidMessage ? 'redBorder' : ''" [selectPlaceholder]="'Select Sites'" [hideOptionsAfter]="2" [responsiveOptionHiding]="false"></gs-select>
              <p *ngIf="showSitesInvalidMessage" class="cl-red fs-12">
                Please select at least one site
              </p>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
          <nz-form-item class="margin-none">
            <nz-form-control class="switch-box">
              <nz-switch formControlName="isUserActive"></nz-switch>
              <label class="switch-label black mr-1">{{
                _fS.userForm.get("isUserActive").value ? "Active" : "Inactive"
                }}</label>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-template #footerTpl>
    <div class="d-flex justify-content-end">
      <button nz-button nzType="default" (click)="handleCancel()" class="default-btn width-100">
        Cancel
      </button>
      <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingUser"
        class="medium-btn small-btn width-100">
        {{ selectedData != null ? "Update" : "Add" }}
      </button>
    </div>
  </ng-template>
</nz-modal>